import * as yup from 'yup';
import { vesselRegexWith5D } from '../../../../utils/regex';
// import { NumericWithOptionalDecimalRegex } from '../../../../utils/regex';
import { RequestForm } from './types';

export const MainDefaultValue = {
  vertical: false,
  safetyEquipmentRequired: false,
  outside: false,
  flux: false,
  absDiff: false,
  crsDiff: false,
  jobId: '',
  manufacturer: '',
  serialId: '',
  model: '',
  vessel: '',
  tubeType: '',
  material: '',
  OD: '',
  ID: '',
  tubeLength: '',
  tubeCount: '',
  NWT: '',
  NWTBellLand: '',
  NWTUnderFins: '',
  note: '',
  workHrs: '',
  retestOf: '',
};

export const validationSchema = yup.object().shape({
  [RequestForm.NWT]: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      'is-valid-nwt',
      'NWT must be a number with up to 5 digits, optionally followed by a decimal with up to 2 digits.',
      (value) => !value || vesselRegexWith5D.test(value), // Only validate if value exists
    ),
  [RequestForm.NWTBellLand]: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      'is-valid-nwt',
      'NWT/Bell/Land must be a number with up to 5 digits, optionally followed by a decimal with up to 2 digits.',
      (value) => !value || vesselRegexWith5D.test(value), // Only validate if value exists
    ),
  [RequestForm.NWTUnderFins]: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      'is-valid-nwt',
      'NWT Under Fins must be a number with up to 5 digits, optionally followed by a decimal with up to 2 digits.',
      (value) => !value || vesselRegexWith5D.test(value), // Only validate if value exists
    ),
  // .max(5, 'NWT must not exceed 5 characters in length'),
});
